import { SwipeableProductListProps } from "@made-people/blueprint-swipeable-product-list";
import { ChevronLeft } from "../../../assets/icons/ChevronLeft";
import { ChevronRight } from "../../../assets/icons/ChevronRight";

export const SwipeableProductList = {
  settings: {
    template: "template1",
    navigation: {
      prevIcon: <ChevronLeft />,
      nextIcon: <ChevronRight />,
    },
    itemsInView: { initial: "2.1", lg: "4" },
    variants: {
      background: "none",
      layout: "stacked",
    },
    // headerSettings: {
    //   heading: {
    //     variants: {
    //       eyebrowSize: { initial: "sm", lg: "md" },
    //       headingSize: { initial: "lg", md: "xl", lg: "2xl" },
    //     },
    //   },
    // },
  },
  productCardSettings: {
    templateProps: {
      template: "1",
      details: {
        variants: {
          spacing: "false",
        },
      },
      gallery: {
        variants: {
          rounded: "true",
        },
      },
    },
  },
} satisfies SwipeableProductListProps;
